import { useParams } from "react-router";

export function useKeyedParams<E extends object>(): E {
  return useParams() as E;
}
